import React, { useEffect } from "react";
import * as echarts from "echarts";

const StackedBarHappiness = ({ chartData }: any) => {
  useEffect(() => {
    if (!chartData || !chartData.series || !chartData.categories) {
      console.warn("chartData is missing or incorrectly formatted");
      return;
    }

    const chartElement = document.getElementById(
      "bar-chart-happiness"
    ) as HTMLDivElement;
    if (!chartElement) return;

    const chart = echarts.init(chartElement);

    function getBarWidth(minWidth: number): number | string {
      const categoriesCount = chartData.categories.length;
      return categoriesCount <= 3 ? minWidth : "auto";
    }

    const series = chartData.series.map((item: any) => ({
      name: item.name.charAt(0).toUpperCase() + item.name.slice(1) + " Index",
      type: "bar",
      emphasis: { focus: "series" },
      itemStyle: { color: item.color, barBorderRadius: [5, 5, 0, 0] }, // Correctly assign colors
      data: item.data, // Use correct data mapping
      barWidth: getBarWidth(6),
    }));

    const options = {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      grid: {
        left: "0%",
        right: "5%",
        bottom: "2%",
        containLabel: true,
      },
      // legend: {
      //   data: series.map((s: any) => s.name),
      //   x: "left",
      // },
      xAxis: [
        {
          type: "category",
          axisTick: { show: false },
          data: chartData.categories,
        },
      ],
      yAxis: [{ type: "value", min: 0, max: 8 }],
      series, // Ensure correct order and structure
    };

    chart.setOption(options);

    const resizeObserver = new ResizeObserver(() => {
      chart.resize();
    });
    resizeObserver.observe(chartElement);

    return () => {
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [chartData]);

  return (
    <div
      id="bar-chart-happiness"
      style={{ width: "100%", height: "257px" }}
    ></div>
  );
};

export default StackedBarHappiness;
